module.exports = {
	// header
	header: {
		welcome: '欢迎来到拍界,祝您拍的愉快！',
		test: {
			final: '进入正式版',
			beta: '进入测试版'
		},
		login: '登录',
		me: '个人中心',
		log_out: '退出',
		customer_service: '客服电话',
		search: '请输入您要搜索的内容',
		nav: {
			home: '首页',
			subject: '标的展示',
			auction: '拍卖会',
			auction_notice: '拍卖公告',
			notice: '拍卖资讯',
			enterprise: '拍卖企业',
			about_us: '关于我们',
			note: '通知公告'
		}

	},
	// footer
	footer: {
		problems: {
			FAQs_and_process: {
				title: '拍卖流程常见问题',
				list_1: '如何报名参加竞拍？',
				list_2: '什么是流拍？',
				list_3: '什么是标的物？'
			},
			auction_rules: {
				title: '拍卖规则',
				list_1: '保证金规则？',
				list_2: '拍卖成交规则？',
				list_3: '拍卖延时规则？',
				list_4: '重新拍卖规则？'
			},
			other_FAQs: {
				title: '其他常见问题',
				list_1: '悔拍怎么办？',
				list_2: '如何办理资产交割？'
			},
			institutional_presence: {
				title: '机构入驻',
				list_1: '拍界官网拍卖'
			},
			official_wechat: {
				title: '官方微信'
			},
			about_us: {
				title: '关于我们',
				list_1: '全国热线：',
				list_2: '400-9005-905',
				list_3: '地址：吉林省长春市南关区亚泰大街2507号'
			}
		},
		keep_on_record: {
			nav: {
				home: '首页',
				subject: '标的',
				notice: '拍卖公告',
				enterprise: '拍卖企业'
			},
			License_No: '许可证编号',
			MIIT: '工信部备案',
			copyright: '拍界版权所有'
		}
	},
	// login
	login: {
		welcome: '欢迎登录拍界平台',
		phone: '手机号',
		code: '验证码',
		send_code: '获取验证码',
		reacquire: '重新获取',
		submit: '登录平台',
		phone_error: '手机号码格式不正确'
	},
	// register 20250620添加
	register: {
		welcome: '欢迎注册拍界平台',
		phone: '手机号',
		password: '登录密码',
		register: '注册',
		phone_error: '手机号码格式不正确',
		password_empty: '密码不能为空'
	},
	// 首页
	home: {
		class: {
			title: '拍品分类',
			used_equipment: '二手设备',
			construction_machinery: '工程机械',
			scrap_metal: '废旧金属',
			waste_precious_metal: '废贵金属',
			waste_paper: '废纸',
			packing: '包装',
			printing: '印刷',
			overstock_of_goods: '货存积压',
			hazardous_chemical_waste: '化工危险废物',
			waste_electronic_appliances: '废电子电器',
			mobile_phone: '手机',
			battery: '电池',
			old_tires_and_rubber: '旧轮胎与橡胶',
			molding_machine: '成型机',
			stock_old_clothes: '库存旧衣服',
			clothing: '服装',
			shoes_and_Hats: '鞋帽',
			waste_glass: '废玻璃',
			waste_wood: '废旧木材',
			Vehicle: '机动车',
			land: '土地',
			house_property: '房产',
			comprehensive: '综合类',
			storage_battery: '蓄电池',

		},
		recommend: {
			title: '为您推荐',
			used_equipment: '二手设备',
			overstock_of_goods: '货存积压',
			scrap_metal: '废旧金属'
		},
		process: {
			title: '竞拍流程',
			step_1: {
				number: '第一步',
				describe: '注册认证'
			},
			step_2: {
				number: '第二步',
				describe: '拍前准备'
			},
			step_3: {
				number: '第三步',
				describe: '交保证金'
			},
			step_4: {
				number: '第四步',
				describe: '出价竞拍'
			},
			step_5: {
				number: '第五步',
				describe: '竞拍成功'
			},
			step_6: {
				number: '第六步',
				describe: '线下取货'
			}
		},
		big_title: {
			special_auction: {
				title: '拍卖专场',
				auction_platform: '拍卖平台：',
				current_price: '当前价位',
				opening_time: '开拍时间：',
				subject_address: '标的所在：'
			},
			closing_case: {
				title: '成交案例',
				transaction_price: '成交价',
				closing_time: '成交时间'
			},
			enterprise: {
				title: '拍卖企业',
				entry_time: '入驻时间：'
			},
			recent_notice: '近期预告'
		},
		more: '更多>>'
	},
	// 标的
	subject: {
		subject_type: '标的分类：',
		subject_state: '标的状态：',
		subject_address: '标的所在地：',
		no_data: '暂时没有数据',
		pagination: {
			first: '首页',
			last: '尾页',
			prev: '上一页',
			next: '下一页',
			all: '共',
			pages: '页',
			record: '条记录'
		},
		list: {
			starting_price: '起拍价：',
			end_price: '成交价：',
			number: '编号：',
			auction_time: '拍卖时间：',
			subject_address: '所在地：',
			sign_up: '报名',
			onlookers: '围观',
			state: {
				s_1: '立即报名',
				s_2: '进行中',
				s_3: '已结束'
			}
		}
	},
	// 标的详情
	subject_details: {
		enterprise: '拍卖企业：',
		contact_information: '联系方式：',
		see_the_introduction_of_the_subject_for_the_large_drawing: '详见标的介绍',
		payment_location_of_online_margin: '线上保证金的缴纳位置',
		current_price: '当前价',
		distance_start_time: '距离开始时间：',
		sign_up: '报名',
		onlookers: '围观',
		number: '编号',
		leading_number: '领先编号：',
		your_number: '您的编号：',
		auctioneers_speech: '拍卖师发言',
		auctioneer_information: '拍卖师信息',
		state: '状态',
		bidding_number: '竞买号',
		offer: '出价',
		service_charge: '由平台提供拍卖服务，成交后需支付综合服务费，按成交金额3%的比例收取',
		starting_price: '起拍价：',
		deposit: '保证金：',
		markup_range: '加价幅度：',
		evaluation_price: '评估价：',
		reserve_price: '保留价：',
		preemptive_right_holder: '优先购买权人：',
		free_bidding_time: '自由竞价：',
		time_limited_bidding_time: '限时竞价：',
		opening_time: '开拍时间：',
		please_pay_deposit_after_registration: '报名后请缴纳保证金：',
		how_to_pay_the_deposit: '如何缴纳保证金?',
		bidding_rules: '竞价规则：一人报名，即视为接受标的底价，已满足成交条件，即可成交',
		final_payment_method: '尾款支付方式',
		offline_transaction: '线下交易',
		deadline_for_final_payment: '尾款支付截止时间',
		within_3_working_days_after_the_transaction: '成交后3个工作日内',
		introduction_of_subject_matter: '标的介绍',
		notice: '拍卖公告',
		bidding_notice: '竞拍须知',
		bidding_record: '竞价记录',
		enrollment_ended: '报名结束',
		no_data: '暂无',
		day: '天',
		hour: '时',
		min: '分钟',
		s: '秒',
		yes: '有',
		no: '无',
		lead: '领先',
		eliminate: '淘汰',
		price: '价格',
		time: '时间',
	}
}